import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import './Admin.css';
import Navbar from './Navbar';

const Admin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nombre: '',
    departamento: '',
    localidad: '',
    barrio: '',
    empresa: '',
    inspector: '',
    avance: 0,
    planos: '',
    memorias: '',
    detalles: '',
    imagenes: '',
    categoria: 'Otras Areas',
    observaciones: '',
    ultima_modificacion: '',
  });

  const [data, setData] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showObservacionesModal, setShowObservacionesModal] = useState(false);
  const [currentObservaciones, setCurrentObservaciones] = useState('');

  const [filters, setFilters] = useState({
    id: '',
    nombre: '',
    departamento: '',
    localidad: '',
    inspector: '',
    estado: '',
    categoria: '',
    avanceMin: 0,
    avanceMax: 100,
  });

  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  }, []);

  const handleFilterChange = useCallback((e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  }, []);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    const updatedFormData = {
      ...formData,
      ultima_modificacion: new Date().toISOString(),
    };

    const url = editMode
      ? `${process.env.REACT_APP_API_URL}/api/obras/${currentId}`
      : `${process.env.REACT_APP_API_URL}/api/obras`;

    const method = editMode ? 'PUT' : 'POST';

    try {
      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updatedFormData),
      });

      const dataFromServer = await response.json();

      if (response.ok) {
        if (editMode) {
          setData(prev =>
            prev.map(item =>
              item.id === currentId ? { ...item, ...updatedFormData } : item
            )
          );
          setEditMode(false);
        } else {
          setData(prev => [
            ...prev,
            { ...updatedFormData, id: dataFromServer.id, estado: dataFromServer.estado },
          ]);
        }

        setFormData({
          nombre: '',
          departamento: '',
          localidad: '',
          barrio: '',
          empresa: '',
          inspector: '',
          avance: 0,
          planos: '',
          memorias: '',
          detalles: '',
          imagenes: '',
          categoria: 'Otras Areas',
          observaciones: '',
          ultima_modificacion: '',
        });

        setShowModal(false);
      } else {
        console.error('Error al guardar la obra:', dataFromServer);
      }
    } catch (error) {
      console.error('Error de red:', error);
    }
  }, [formData, currentId, editMode]);

  const handleDelete = useCallback(async (id) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/obras/${id}`, { method: 'DELETE' });
      if (response.ok) {
        setData(prev => prev.filter(item => item.id !== id));
      } else {
        console.error('Error al eliminar la obra');
      }
    } catch (error) {
      console.error('Error de red:', error);
    }
  }, []);

  const handleEdit = (item) => {
    setFormData({
      nombre: item.nombre,
      departamento: item.departamento || '',
      localidad: item.localidad,
      barrio: item.barrio,
      empresa: item.empresa,
      inspector: item.inspector,
      avance: item.avance,
      planos: item.planos || '',
      memorias: item.memorias || '',
      detalles: item.detalles,
      imagenes: item.imagenes,
      categoria: item.categoria,
      observaciones: item.observaciones,
      ultima_modificacion: item.ultima_modificacion,
    });
    setEditMode(true);
    setCurrentId(item.id);
    setShowModal(true);
  };

  const handleShowObservaciones = (observaciones) => {
    setCurrentObservaciones(observaciones);
    setShowObservacionesModal(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/obras`);
        if (response.ok) {
          const dataFromServer = await response.json();
          setData(dataFromServer);
        } else {
          console.error('Error al cargar las obras');
        }
      } catch (error) {
        console.error('Error de red:', error);
      }
    };
    fetchData();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/login');
  };

  const getEstado = (avance) => {
    if (avance === 100) return 'Finalizado';
    if (avance > 0) return 'En ejecución';
    return 'No iniciado';
  };

// ...importaciones
const normalizeText = (text) =>
  text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

const filteredData = data.filter(item => (
  (filters.id ? item.id === parseInt(filters.id) : true) &&
  (filters.nombre ? normalizeText(item.nombre).includes(normalizeText(filters.nombre)) : true) &&
  (filters.departamento ? normalizeText(item.departamento || '').includes(normalizeText(filters.departamento)) : true) &&
  (filters.localidad ? normalizeText(item.localidad).includes(normalizeText(filters.localidad)) : true) &&
  (filters.inspector ? normalizeText(item.inspector).includes(normalizeText(filters.inspector)) : true) &&
  (filters.estado ? getEstado(item.avance).toLowerCase() === filters.estado.toLowerCase() : true) &&
  (filters.categoria ? normalizeText(item.categoria).includes(normalizeText(filters.categoria)) : true) &&
  (filters.avanceMin ? item.avance >= parseInt(filters.avanceMin) : true) &&
  (filters.avanceMax ? item.avance <= parseInt(filters.avanceMax) : true)
));

  

  return (
    <div className="admin-page">
      <Navbar userName="Administrador" onLogout={handleLogout} />
      <div className="admin-wrapper">
        <button className="Cargar-mover" onClick={() => setShowModal(true)}>Cargar Obra</button>

        {showModal && (
          <div className="modal">
            <h2>{editMode ? 'Editar Obra' : 'Cargar Obra'}</h2>
            <form onSubmit={handleSubmit}>
              <input type="text" name="nombre" value={formData.nombre} onChange={handleInputChange} placeholder="Nombre" required />
              <input type="text" name="departamento" value={formData.departamento} onChange={handleInputChange} placeholder="Departamento" required />
              <input type="text" name="localidad" value={formData.localidad} onChange={handleInputChange} placeholder="Localidad" required />
              <input type="text" name="barrio" value={formData.barrio} onChange={handleInputChange} placeholder="Barrio" required />
              <input type="text" name="empresa" value={formData.empresa} onChange={handleInputChange} placeholder="Empresa" required />
              <input type="text" name="inspector" value={formData.inspector} onChange={handleInputChange} placeholder="Inspector" required />
              <input type="number" name="avance" value={formData.avance} onChange={handleInputChange} placeholder="Avance (%)" required />
              <input type="text" name="planos" value={formData.planos} onChange={handleInputChange} placeholder="Planos (URL)" required />
              <input type="text" name="memorias" value={formData.memorias} onChange={handleInputChange} placeholder="Memorias (URL)" required />
              <input type="text" name="detalles" value={formData.detalles} onChange={handleInputChange} placeholder="Detalles (URL)" required />
              <input type="text" name="imagenes" value={formData.imagenes} onChange={handleInputChange} placeholder="Imágenes (URL)" required />
              <textarea name="observaciones" value={formData.observaciones} onChange={handleInputChange} placeholder="Observaciones" rows="4" required />
              <input type="text" name="ultima_modificacion" value={format(new Date(formData.ultima_modificacion || new Date()), 'dd/MM/yyyy HH:mm', { locale: es })} onChange={handleInputChange} readOnly />
              <select name="categoria" value={formData.categoria} onChange={handleInputChange}>
                <option value="Salud">Salud</option>
                <option value="Educacion">Educación</option>
                <option value="Otras Areas">Otras Áreas</option>
              </select>
              <button type="submit">{editMode ? 'Actualizar' : 'Agregar'}</button>
              <button type="button" onClick={() => setShowModal(false)}>Cancelar</button>
            </form>
          </div>
        )}

        {showObservacionesModal && (
          <div className="modal">
            <h2>Observaciones</h2>
            <p>{currentObservaciones}</p>
            <button type="button" onClick={() => setShowObservacionesModal(false)}>Cerrar</button>
          </div>
        )}

        <h2 className="titulo-filtros">Filtros</h2>
        <form className="filtro-mover">
          <input type="number" name="id" value={filters.id} onChange={handleFilterChange} placeholder="Filtrar por ID" />
          <input type="text" name="departamento" value={filters.departamento} onChange={handleFilterChange} placeholder="Filtrar por Departamento" />
          <input type="text" name="nombre" value={filters.nombre} onChange={handleFilterChange} placeholder="Filtrar por Nombre" />
          <input type="text" name="localidad" value={filters.localidad} onChange={handleFilterChange} placeholder="Filtrar por Localidad" />
          <input type="text" name="inspector" value={filters.inspector} onChange={handleFilterChange} placeholder="Filtrar por Inspector" />
          <select name="estado" value={filters.estado} onChange={handleFilterChange}>
            <option value="">Filtrar por Estado</option>
            <option value="Finalizado">Finalizado</option>
            <option value="En ejecución">En ejecución</option>
            <option value="No iniciado">No iniciado</option>
          </select>
          <select name="categoria" value={filters.categoria} onChange={handleFilterChange}>
            <option value="">Filtrar por Categoría</option>
            <option value="Salud">Salud</option>
            <option value="Educacion">Educación</option>
            <option value="Otras Areas">Otras Áreas</option>
          </select>
          <input type="number" name="avanceMin" value={filters.avanceMin} onChange={handleFilterChange} placeholder="Avance Mínimo" />
          <input type="number" name="avanceMax" value={filters.avanceMax} onChange={handleFilterChange} placeholder="Avance Máximo" />
        </form>

        <h2 className="titulo-lista">Lista de Obras</h2>
        <div className="table-container">
          <table className="admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nombre</th>
                <th>Departamento</th>
                <th>Localidad</th>
                <th>Barrio</th>
                <th>Empresa</th>
                <th>Inspector</th>
                <th>Avance</th>
                <th>Estado</th>
                <th>Categoría</th>
                <th>Planos</th>
                <th>Memorias</th>
                <th>Detalles</th>
                <th>Imágenes</th>
                <th>Observaciones</th>
                <th>Última Modificación</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map(item => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.nombre}</td>
                  <td>{item.departamento || '-'}</td>
                  <td>{item.localidad}</td>
                  <td>{item.barrio}</td>
                  <td>{item.empresa}</td>
                  <td>{item.inspector}</td>
                  <td>
                    <div className="progress-wrapper">
                      <div className="progress">
                        <div
                          className={`progress-bar ${item.avance > 0 && item.avance < 100 ? 'in-progress' : item.avance === 100 ? 'completed' : ''}`}
                          style={{ width: `${item.avance}%` }}
                        ></div>
                      </div>
                      <span className="progress-text">{item.avance}%</span>
                    </div>
                  </td>
                  <td>{getEstado(item.avance)}</td>
                  <td>{item.categoria}</td>
                  <td><a href={item.planos} target="_blank" rel="noopener noreferrer" className="btn-link-detalles">Ver Planos</a></td>
                  <td><a href={item.memorias} target="_blank" rel="noopener noreferrer" className="btn-link-imagenes">Ver Memorias</a></td>
                  <td><a href={item.detalles} target="_blank" rel="noopener noreferrer" className="btn-link-detalles">Ver Detalles</a></td>
                  <td><a href={item.imagenes} target="_blank" rel="noopener noreferrer" className="btn-link-imagenes">Ver Imágenes</a></td>
                  <td><button className="obs-btn" onClick={() => handleShowObservaciones(item.observaciones)}>Ver Observaciones</button></td>
                  <td className="last-modified">{format(new Date(item.ultima_modificacion), 'dd/MM/yyyy HH:mm', { locale: es })}</td>
                  <td>
                    <button className="edit-btn" onClick={() => handleEdit(item)}>Editar</button>
                    <button className="delete-btn" onClick={() => handleDelete(item.id)}>Eliminar</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Admin;
